import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderDelegateRight } from './../header-delegateright';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { formatDelegateRight } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-edit-delegaterights',
    templateUrl: './edit-delegaterights.component.html',
    styleUrls: ['./edit-delegaterights.component.scss'],
})
export class EditDelegateRightsComponent implements OnInit {
    public selectedResult: HeaderDelegateRight;
    public resultResult: any[];

    public errorMessage = '';
    public errorLoaderDialog = false;

    @Input()
    public item: any;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public delegateList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
    ) {
        this.menu.display = true;
        this.selectedResult = new HeaderDelegateRight();
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private async getResult(id) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getdelegateright', id ));
            this.resultResult = wRes.data;
            this.selectedResult.Clear();
            if (id !== 0) {
                this.loadResultData(this.resultResult[0]);
            }
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));	
        }
    }

    private loadResultData(adata) {
        this.selectedResult.load(adata);   
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(result) {
        let wRes: any = {};
        const wdata = formatDelegateRight(result);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatedelegateright', wdata ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes.data });     
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        } 
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
